import { useOnboarding } from '../../context/OnboardingContext';
import { applyStyles } from '../../utils/styleUtils';
import { getImageUrl } from '../../utils/imageUrl';
import { useChoiceSelection } from '../../hooks/useChoiceSelection';

const HorizontalSingleChoiceElement = ({ element }) => {
    const { replaceTemplates } = useOnboarding();
    const { selectedValue, handleSelect } = useChoiceSelection(element);

    const style = applyStyles(element);
    const { height: _h, ...containerStyle } = style;

    const options = element.options || [];
    const spacing = element.spacing ?? 12;
    const textColor = element.textColor || '#ffffff';
    const backgroundColor = element.backgroundColor || '#5F2B68';
    const fullWidth = element.fullWidth || false;
    const contentVerticalAlign = element.contentVerticalAlign || 'center';
    const fontSize = element['font-size'] !== undefined
        ? (typeof element['font-size'] === 'number' ? `${element['font-size']}px` : element['font-size'])
        : undefined;
    const itemHeight = element.height !== undefined
        ? (typeof element.height === 'number' ? `${element.height}px` : element.height)
        : undefined;

    if (!options.length) return null;

    return (
        <div className="horizontal-single-choice-container" style={containerStyle}>
            <div
                className="horizontal-single-choice-wrapper"
                style={fullWidth ? { width: '100%' } : undefined}
            >
                <div
                    className="horizontal-single-choice-row"
                    style={{
                        display: 'flex',
                        gap: spacing,
                        justifyContent: fullWidth ? 'stretch' : 'center',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        width: fullWidth ? '100%' : undefined
                    }}
                >
                    {options.map((option, index) => (
                        <button
                            key={index}
                            className={`horizontal-single-choice-item ${selectedValue === option.value ? 'selected' : ''} ${fullWidth ? 'full-width' : ''}`}
                            style={{
                                backgroundColor,
                                color: textColor,
                                borderColor: selectedValue === option.value ? '#A145B0' : 'transparent',
                                alignItems: contentVerticalAlign === 'top' ? 'flex-start' : contentVerticalAlign === 'bottom' ? 'flex-end' : 'center',
                                ...(fontSize && { fontSize }),
                                ...(itemHeight && { minHeight: itemHeight, height: itemHeight })
                            }}
                            onClick={() => handleSelect(option)}
                        >
                            {option.image ? (
                                <img
                                    src={getImageUrl(replaceTemplates(option.image))}
                                    alt=""
                                    onError={(e) => { e.target.style.display = 'none'; }}
                                />
                            ) : (
                                replaceTemplates(option.text || option.value)
                            )}
                        </button>
                    ))}
                </div>
                {(element.leftDescription || element.rightDescription) && (
                    <div className="horizontal-single-choice-descriptions">
                        <span>{replaceTemplates(element.leftDescription || '')}</span>
                        <span>{replaceTemplates(element.rightDescription || '')}</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default HorizontalSingleChoiceElement;
